import { configureStore } from '@reduxjs/toolkit';

import createSagaMiddleware from 'redux-saga';

import rootReducer from './root-reducer';
import rootSaga from './root-saga';

const sagaMiddleware = createSagaMiddleware();

// Paths whose values are intentionally non-serializable. The dev-mode
// serializableCheck + immutableCheck walk the whole state tree on every
// action and warn for any non-plain value — without these ignores the
// console floods and (under heavy action cascades) the UI lags. Production
// strips both checks, so this only affects dev.
//
//   FbRemoteConfig.remoteConfig — defaultCategory icons are React component
//     functions (pre-existing).
//   /\.error$/ — several sagas catch and dispatch raw Error objects (which
//     have non-serializable stack + prototype). Mask the warning blanket-
//     wide using a regex so we don't have to chase each slice individually.
//     The long-term fix is to .toString() the error in each loadXError
//     reducer, but until then masking keeps the dev console usable.
//   AccessLogs.data / Credentials.data / Credentials.access /
//   People.data / Devices.data —
//     scoped buckets that hold large payloads (AccessLogs at pageSize=5000,
//     plus people/devices/credentials across multiple sites). Walking these
//     on every action took 50-80ms per dispatch in dev, adding ~1-2s lag
//     to first-load. Skipping the subtree is safe — values are plain JSON
//     from the API. Long-term fix is dropping the 5000-row AccessLogs
//     payload via a dedicated /logs/dailyRollup endpoint (deferred).
const ignoredPaths = [
	'FbRemoteConfig.remoteConfig',
	/\.error$/,
	'AccessLogs.data',
	'AccessLogs.dailyByOrg',
	'Credentials.data',
	'Credentials.access',
	'People.data',
	'Devices.data'
];

const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: { ignoredPaths, warnAfter: 200 },
			immutableCheck: { ignoredPaths, warnAfter: 200 }
		}).concat(sagaMiddleware),
	devTools:
		process.env.NODE_ENV === 'production'
			? false
			: {
					maxAge: 100
				}
});
sagaMiddleware.run(rootSaga);
export { store };
